// extracted by mini-css-extract-plugin
export default {"title":"LogOutModal_title__60B81","text":"LogOutModal_text__fcaRP","buttons":"LogOutModal_buttons__tm3bj"};